import React from 'react';
import cn from 'classnames';

import Accordion from 'components/accordion/Accordion';
import Heading from 'components/heading/Heading';
import Icon from 'components/icon/Icon';

import { ITableMobileItem } from 'source/NFR.types';

const TableMobileItem: React.FC<ITableMobileItem> = ({ list, accordion }) => {
  const title = list[1]?.value;
  const subtitle = `${list[0]?.label} ${list[0]?.value}`;

  return (
    <div className="table-mobile-item">
      <Accordion {...accordion} buttonTextForLabel={`${title}`}>
        {({ Collapse, toggle, isOpen }) => (
          <>
            <button className="table-mobile-item--header" onClick={toggle}>
              <Heading className="table-mobile-item--title">
                {title}
                <Icon
                  className={cn('table-mobile-item--icon', {
                    '-opened': isOpen
                  })}
                  name="small-arrow-down"
                  fill={true}
                />
              </Heading>
              <div>{subtitle}</div>
            </button>
            <Collapse>
              <div className="table-mobile-item--list">
                {list.slice(2)?.map(({ displayValue, label, value }) => (
                  <React.Fragment key={value}>
                    <div className="table-mobile-item--list-label">{label}</div>
                    <div className="table-mobile-item--list-value">{displayValue || value}</div>
                  </React.Fragment>
                ))}
              </div>
            </Collapse>
          </>
        )}
      </Accordion>
    </div>
  );
};

TableMobileItem.displayName = 'TableMobileItem';

export default TableMobileItem;
